import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentVersion = '';

  constructor(private http: HttpClient) {}

  checkVersion(): void {
    this.http.get<{ version: string }>('/assets/version.json?nocache=' + new Date().getTime())
      .subscribe({
        next: (data) => {
          if (this.currentVersion && this.currentVersion !== data.version) {
            // Force reload with cache-busting
            window.location.href = window.location.origin + '?reload=' + new Date().getTime();
          }
          this.currentVersion = data.version;
        },
        error: (err) => {
          console.error('Version check failed:', err);
        }
      });
  }
}
